export default __webpack_public_path__ + "static/media/mgi.7d07009a.png";